export enum CopperIntroType {
  New,
  Old,
}
